<template lang="pug">
.homepageSection2Component#for
  .sectionContainer
    .title Все необходимое, чтобы вашему ребенку было легко и интересно учиться!
    .features
      .cell
        .item(data-aos="fade-left")
          .value 150
          .label увлекательных видео
      .cell(
        data-aos="fade-left"
        data-aos-delay="200"
      )
        .item
          .value 700
          .label разборов заданий из учебника и рабочей тетради
      .cell(
        data-aos="fade-left"
        data-aos-delay="400"
      )
        .item
          .value 800
          .label дополнительных интерактивных заданий
      .cell(
        data-aos="fade-left"
        data-aos-delay="600"
      )
        .item
          .value 450
          .label заданий для подготовки к ВПР
</template>

<script>
import homepageData from '@/mocks/homepage.json'

export default {
  setup () {
    const data = homepageData.section2

    return {
      data
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageSection2Component
  background: $cWhite
  > .sectionContainer
    > .title
      font-family: GolosTextWebRegular, serif
      font-style: normal
      font-weight: 600
      font-size: 32px
      line-height: 120%
      text-align: center
      color: $cBlack
      max-width: 168*$u
      margin: 0 auto 13*$u

    > .features
      display: grid
      grid-template-columns: repeat(4, 1fr)
      grid-gap: 6*$u

      > .cell

        > .item
          width: 47*$u
          max-width: 100%
          margin: 0 auto

          > .value
            font-family: GolosTextWebBold, serif
            font-style: normal
            font-weight: bold
            font-size: 60px
            line-height: 120%
            color: #FF6D43
            text-align: center

          > .label
            font-family: GolosTextWebRegular, serif
            font-style: normal
            font-weight: 600
            font-size: 20px
            line-height: 120%
            text-align: center
            color: $cDarkBlue

  @media (max-width: 1116px)
    > .sectionContainer
      > .title
        font-size: 28px
        margin-bottom: 10*$u
      > .features
        > .cell
          > .item
            width: 40*$u
            > .value
              font-size: 48px
            > .label
              font-size: 16px

  @media (max-width: 920px)
    > .sectionContainer
      > .title
        font-size: 22px
        margin-bottom: 6*$u
      > .features
        grid-template-columns: repeat(2, 1fr)

  @media (max-width: 560px)
    > .sectionContainer
      > .features
        grid-gap: 3*$u

  @media (max-width: 500px)
    > .sectionContainer
      > .features
        grid-template-columns: 1fr
</style>
